var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaundry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8.015L14 8C12.335 8 11 9.335 11 11V35C11 36.665 12.335 38 14 38H32C33.665 38 35 36.665 35 35V11C35 9.335 33.665 8.015 32 8.015ZM32 35H14L13.985 11H32V35Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.5C17.8284 15.5 18.5 14.8284 18.5 14C18.5 13.1716 17.8284 12.5 17 12.5C16.1716 12.5 15.5 13.1716 15.5 14C15.5 14.8284 16.1716 15.5 17 15.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 15.5C22.3284 15.5 23 14.8284 23 14C23 13.1716 22.3284 12.5 21.5 12.5C20.6716 12.5 20 13.1716 20 14C20 14.8284 20.6716 15.5 21.5 15.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 33.5C27.14 33.5 30.5 30.14 30.5 26C30.5 21.86 27.14 18.5 23 18.5C18.86 18.5 15.5 21.86 15.5 26C15.5 30.14 18.86 33.5 23 33.5ZM26.54 22.46C28.49 24.41 28.49 27.59 26.54 29.54C24.59 31.49 21.41 31.49 19.46 29.54L26.54 22.46Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/laundry.eff601925be8b13d0a0cf2ba5007bd86.svg";
export { ForwardRef as ReactComponent };